import { Lock, LockOpen } from "@mui/icons-material";
import localize from "../../../common/localize";
import { Box } from "@mui/material";

export default function AccessStatus({ isPublic }) {
  return (
    <Box className="flex justify-center w-full">
      <Box className="flex gap-2 items-center">
        {isPublic ? (
          <LockOpen sx={{ color: "#1976d2", height: "18px", width: "18px" }} />
        ) : (
          <Lock sx={{ color: "gray", height: "18px", width: "18px" }} />
        )}
        {isPublic ? localize.is_public : localize.is_private}
      </Box>
    </Box>
  );
}
